// LanguageMenuModalView.jsx
import React from 'react';
import PropTypes from 'prop-types';

import ModalView from '../container/ModalView.js';

import UniversalContainer from '../component/UniversalContainer.jsx';

import { breakpoint } from '../style/variables.js';

const MODAL_VIEW_STYLE = {
  position: 'static',
};

export const LanguageMenuModalView = ({ modalViewRootId, deviceWidth }) => {
  const isMobile = deviceWidth <= breakpoint.mobile;
  const shouldUseDropdownLayout = !isMobile && modalViewRootId;
  return (
    <ModalView
      id="LanguageMenu"
      rootId={shouldUseDropdownLayout ? `#${modalViewRootId}` : undefined}
      modalViewStyle={shouldUseDropdownLayout ? MODAL_VIEW_STYLE : undefined}
      render={() => (
        <UniversalContainer
          filename="LanguageMenu"
          useSuspense={false}
          shouldUseDropdownLayout={shouldUseDropdownLayout}
        />
      )}
    />
  );
};

LanguageMenuModalView.propTypes = {
  modalViewRootId: PropTypes.string,
  deviceWidth: PropTypes.number,
};

LanguageMenuModalView.defaultProps = {
  modalViewRootId: null,
  deviceWidth: 0,
};

export default LanguageMenuModalView;
